import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useFocusOutside, usePromise, useTooltip } from '../../hooks';
export const Autocomplete = (props) => {
    const tooltip = useTooltip(props.tooltip);
    const id = React.useId();
    const items = usePromise(props.options);
    const input = React.useRef(null);
    const options = React.useRef(null);
    const [stateValue, setValue] = React.useState('');
    const [stateFocused, setFocused] = React.useState(false);
    const [stateHovered, setHovered] = React.useState(null);
    const empty = { 'value': '', 'title': 'Select...' };
    const filtered = (items || [])
        .map((x) => ({ 'value': props.optionKey(x), 'title': props.optionLabel(x) }))
        .filter((x) => x.title.toLowerCase().includes(stateValue.toLowerCase()));
    React.useEffect(() => {
        setHovered(filtered.length ? filtered[0].value : null);
    }, [filtered.length]);
    React.useEffect(() => {
        const parent = options.current;
        if (!!parent) {
            const target = parent.getElementsByClassName('hovered')[0];
            if (!!target) {
                // const boundsParent = parent.getBoundingClientRect()
                // const boundsTarget = target.getBoundingClientRect()
                if (target.offsetTop + target.offsetHeight > parent.scrollTop + parent.clientHeight) {
                    parent.scrollTo({
                        'top': target.offsetTop + target.offsetHeight - parent.clientHeight,
                        'behavior': 'smooth',
                    });
                }
                if (target.offsetTop < parent.scrollTop) {
                    parent.scrollTo({
                        'top': target.offsetTop,
                        'behavior': 'smooth',
                    });
                }
            }
        }
    }, [stateHovered, options.current]);
    const keydown = (e) => {
        switch (e.key) {
            case 'Enter':
            case 'ArrowUp':
            case 'ArrowDown':
                e.preventDefault();
                break;
            default:
                break;
        }
    };
    const blur = () => {
        input.current?.blur();
        setFocused(false);
    };
    const container = useFocusOutside(blur);
    const select = (x) => {
        props.onChange && props.onChange(x);
        blur();
    };
    const keyup = (e) => {
        const hoveredIndex = filtered.findIndex((x) => x.value === stateHovered);
        switch (e.key) {
            case 'Enter':
                select(stateHovered);
                break;
            case 'Escape':
                blur();
                break;
            case 'ArrowUp':
                if (hoveredIndex > 0) {
                    setHovered(filtered[hoveredIndex - 1].value);
                }
                e.preventDefault();
                break;
            case 'ArrowDown':
                if (hoveredIndex < filtered.length) {
                    setHovered(filtered[hoveredIndex + 1].value);
                }
                e.preventDefault();
                break;
            default:
                // console.log(e.key)
                break;
        }
    };
    return _jsx(_Fragment, { children: _jsxs("div", { ref: container, className: `form-floating ${props.className}`, style: props.style, children: [_jsx("ul", { ref: options, className: `position-absolute w-100 rounded-bottom bg-white list-unstyled p-1 ${!stateFocused ? 'd-none' : ''}`, style: { 'maxHeight': '250px', 'overflowX': 'auto', 'top': '100%', 'left': 0, 'zIndex': 999 }, children: filtered.map((x) => _jsx("li", { role: "button", className: `p-1 pointer ${props.value === x.value ? 'text-primary bg-light selected' : ''} ${stateHovered === x.value ? 'bg-light fw-bold hovered' : ''}`, onMouseMove: () => setHovered(x.value), onClick: () => select(x.value), tabIndex: -1, children: x.title }, x.value)) }), _jsx("input", { ref: input, id: id, value: stateFocused ? stateValue : !!props.value && !!items?.length ? ((item) => item ? props.optionLabel(item) : '')(items.find((x) => props.optionKey(x) === props.value)) : '', type: "text", className: `form-control ${{ 'sm': 'form-control-sm', 'md': '', 'lg': 'form-control-lg' }[props.size || 'md']} ${!!props.invalid && 'is-invalid'}`, disabled: props.disabled, onFocus: () => {
                        setFocused(true);
                        setValue('');
                        setHovered(empty.value);
                    }, onInput: (e) => setValue(e.target.value), onKeyDown: keydown, onKeyUp: keyup }), _jsxs("label", { htmlFor: id, className: "form-label", children: [props.label, props.required && _jsx("span", { className: "text-danger", children: "*" })] }), props.tooltip && _jsxs("span", { className: "position-absolute border border-primary text-primary rounded-circle d-inline-block text-center fw-bold", style: { 'right': '30px', 'top': '50%', 'transform': 'translateY(-50%)', 'zIndex': 100, 'width': '24px', 'height': '24px' }, ref: tooltip.refTrigger, ...tooltip.triggerProps, children: ["?", _jsx(tooltip.Tooltip, {})] }), !props.invalid ? undefined : _jsx(_Fragment, { children: _jsx("div", { className: "invalid-feedback", children: props.invalid }) })] }) });
};
export default Autocomplete;
